/* eslint-disable jira/filename-case */
export const FEATURES = {
	STATUS_PAGES: 'STATUS_PAGES',
	STATUS_PAGES_DRAFT_ONLY: 'STATUS_PAGES_DRAFT_ONLY',
	STATUS_PAGES_SEND_UPDATE: 'STATUS_PAGES_SEND_UPDATE',
	SUGGEST_STAKEHOLDERS: 'SUGGEST_STAKEHOLDERS',
};
